module.exports = __webpack_public_path__ + "static/5-09705af6af0aafa5999c438a2f9bda23.jpg";